import { useTranslate } from "@similarweb/i18n-provider";
import { Tooltip } from "@similarweb/ui-components";

import { RowNameTag } from "app/pages/digital-marketing/keywords-campaigns/shared/styles";

export const ScrapeInProgressBadge = () => {
    const { translate } = useTranslate();

    return (
        <Tooltip content={translate("rankTracker.keywordsReport.table.keyword.scrapeInProgress.tooltip")}>
            <RowNameTag
                fontVariant="tag"
                $cursor="default"
                data-automation="keywords-report-keyword-scrape-in-progress-badge"
            >
                {translate("research.homepage.rank_tracker.table.tag.in_progress")}
            </RowNameTag>
        </Tooltip>
    );
};
